import { render, staticRenderFns } from "./shareable-link.vue?vue&type=template&id=41451043&scoped=true&"
import script from "./shareable-link.ts?vue&type=script&lang=ts&"
export * from "./shareable-link.ts?vue&type=script&lang=ts&"
import style0 from "./shareable-link.scss?vue&type=style&index=0&id=41451043&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41451043",
  null
  
)

export default component.exports